import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { WidgetType } from '../../utils/widgetsUtils';

export const CardSectionWidgetStaticSchema = BaseWidgetSchema(WidgetType.CardSection).extend({
  layout: z.record(z.unknown()),
  style: z.record(z.unknown())
});

export type CardSectionWidgetStaticSchemaType = z.infer<typeof CardSectionWidgetStaticSchema>;
